import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../services/toast.service';
@Component({
  selector: 'lms-notice',
  templateUrl: './notice.component.html'
})
export class NoticeComponent implements OnInit {
  public noticeOptions: any = {};

  constructor(public toastService: ToastService) {}

  ngOnInit() {
    this.toastService.notice.subscribe((options: any) => {
      this.noticeOptions = options && options.context === this.toastService.APP_CONTEXT ? options : null;
    });
  }
}
